var _defs, _g, _g2, _g3, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmpresasMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f07281;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #f9f3f1;\n      }\n\n      .cls-3 {\n        fill: #8ac9fe;\n      }\n\n      .cls-4 {\n        fill: #7a8c98;\n      }\n\n      .cls-5 {\n        fill: #efe2dd;\n      }\n\n      .cls-6 {\n        fill: #e5e1e5;\n      }\n\n      .cls-7 {\n        fill: #d6694b;\n      }\n\n      .cls-8 {\n        fill: #000;\n      }\n\n      .cls-9 {\n        fill: #ccf49e;\n      }\n\n      .cls-10 {\n        fill: #f3eae6;\n      }\n\n      .cls-11 {\n        fill: #fed402;\n      }\n\n      .cls-12 {\n        fill: #c4573a;\n      }\n\n      .cls-13 {\n        fill: #b3e59e;\n      }\n\n      .cls-14 {\n        fill: #fff;\n      }\n\n      .cls-15 {\n        fill: #293c66;\n      }\n\n      .cls-16 {\n        fill: #eb5569;\n      }\n\n      .cls-17 {\n        fill: #faf6f6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "69.6 133.4 69.6 414.8 251.8 414.8 433.9 414.8 433.9 133.4 69.6 133.4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 69.6,
    y: 133.4,
    width: 364.2,
    height: 26.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 137.1,
    y: 76.9,
    width: 229.4,
    height: 311.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 337.1,
    y: 76.9,
    width: 29.3,
    height: 311.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 123.6,
    y: 388.5,
    width: 256.4,
    height: 26.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 350.6,
    y: 388.5,
    width: 29.3,
    height: 26.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 123.6,
    y: 50.6,
    width: 256.4,
    height: 26.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 350.6,
    y: 50.6,
    width: 29.3,
    height: 26.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 69.6,
    y: 303.3,
    width: 27.3,
    height: 58.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 69.6,
    y: 203.2,
    width: 27.3,
    height: 58.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 406.6,
    y: 303.3,
    width: 27.3,
    height: 58.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 406.6,
    y: 203.2,
    width: 27.3,
    height: 58.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 173.3,
    y: 113.1,
    width: 27.3,
    height: 58.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 238.1,
    y: 113.1,
    width: 27.3,
    height: 44.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 302.9,
    y: 113.1,
    width: 27.3,
    height: 58.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 305.2,
    y: 268.9,
    width: 25,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 305.2,
    y: 339.1,
    width: 25,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 305.2,
    y: 291.9,
    width: 25,
    height: 47.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 173.3,
    y: 268.9,
    width: 25,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 173.3,
    y: 339.1,
    width: 25,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 173.3,
    y: 291.9,
    width: 25,
    height: 47.2
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 198.3,
    y: 268.9,
    width: 107,
    height: 93.3
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "341.2 268.9 162.3 268.9 162.3 244.3 251.8 188.7 341.2 244.3 341.2 268.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 162.3,
    y: 362.2,
    width: 178.9,
    height: 26.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M433.9,420.3h-90.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5h85V133.4c0-3,2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5v281.4c0,3-2.5,5.5-5.5,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M319.9,420.3H69.6c-3,0-5.5-2.5-5.5-5.5V133.4c0-3,2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5v275.9h244.8c3,0,5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M137.1,165.2h-67.4c-3,0-5.5-2.5-5.5-5.5v-26.3c0-3,2.5-5.5,5.5-5.5h67.4c3,0,5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5h-61.9v15.3h61.9c3,0,5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M433.9,165.2h-67.4c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5h61.9v-15.3h-61.9c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5h67.4c3,0,5.5,2.5,5.5,5.5v26.3c0,3-2.5,5.5-5.5,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M366.4,394h-229.4c-3,0-5.5-2.5-5.5-5.5V76.9c0-3,2.5-5.5,5.5-5.5h229.4c3,0,5.5,2.5,5.5,5.5v311.6c0,3-2.5,5.5-5.5,5.5ZM142.6,383h218.4V82.4h-218.4v300.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M341.2,394h-178.9c-3,0-5.5-2.5-5.5-5.5v-26.3c0-3,2.5-5.5,5.5-5.5h178.9c3,0,5.5,2.5,5.5,5.5v26.3c0,3-2.5,5.5-5.5,5.5ZM167.8,383h167.9v-15.3h-167.9v15.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M379.9,420.3c-3,0-5.5-2.5-5.5-5.5v-20.8h-245.4v20.8c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5v-26.3c0-3,2.5-5.5,5.5-5.5h256.4c3,0,5.5,2.5,5.5,5.5v26.3c0,3-2.5,5.5-5.5,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M379.9,82.4H123.6c-3,0-5.5-2.5-5.5-5.5v-26.3c0-3,2.5-5.5,5.5-5.5h27.8c3,0,5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5h-22.3v15.3h245.4v-15.3h-200.7c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5h206.2c3,0,5.5,2.5,5.5,5.5v26.3c0,3-2.5,5.5-5.5,5.5h-.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M341.2,274.4h-178.9c-3,0-5.5-2.5-5.5-5.5v-24.5c0-1.9,1-3.7,2.6-4.7l89.5-55.6c1.8-1.1,4-1.1,5.8,0l89.5,55.6c1.6,1,2.6,2.8,2.6,4.7v24.5c0,3-2.5,5.5-5.5,5.5h-.1ZM167.8,263.4h167.9v-16l-84-52.2-84,52.2v16h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96.9,367.7h-27.3c-3,0-5.5-2.5-5.5-5.5v-58.9c0-3,2.5-5.5,5.5-5.5h27.3c3,0,5.5,2.5,5.5,5.5v58.9c0,3-2.5,5.5-5.5,5.5ZM75.1,356.7h16.3v-47.9h-16.3s0,47.9,0,47.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96.9,267.6h-27.3c-3,0-5.5-2.5-5.5-5.5v-58.9c0-3,2.5-5.5,5.5-5.5h27.3c3,0,5.5,2.5,5.5,5.5v58.9c0,3-2.5,5.5-5.5,5.5ZM75.1,256.6h16.3v-47.9h-16.3s0,47.9,0,47.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M433.9,367.7h-27.3c-3,0-5.5-2.5-5.5-5.5v-58.9c0-3,2.5-5.5,5.5-5.5h27.3c3,0,5.5,2.5,5.5,5.5v58.9c0,3-2.5,5.5-5.5,5.5ZM412.1,356.7h16.3v-47.9h-16.3v47.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M433.9,267.6h-27.3c-3,0-5.5-2.5-5.5-5.5v-58.9c0-3,2.5-5.5,5.5-5.5h27.3c3,0,5.5,2.5,5.5,5.5v58.9c0,3-2.5,5.5-5.5,5.5ZM412.1,256.6h16.3v-47.9h-16.3v47.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M200.6,177.5h-27.3c-3,0-5.5-2.5-5.5-5.5v-58.9c0-3,2.5-5.5,5.5-5.5h27.3c3,0,5.5,2.5,5.5,5.5v58.9c0,3-2.5,5.5-5.5,5.5ZM178.8,166.5h16.3v-47.9h-16.3v47.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M265.4,162.8h-27.3c-3,0-5.5-2.5-5.5-5.5v-44.3c0-3,2.5-5.5,5.5-5.5h27.3c3,0,5.5,2.5,5.5,5.5v44.3c0,3-2.5,5.5-5.5,5.5ZM243.6,151.9h16.3v-33.3h-16.3v33.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M330.2,177.5h-27.3c-3,0-5.5-2.5-5.5-5.5v-58.9c0-3,2.5-5.5,5.5-5.5h27.3c3,0,5.5,2.5,5.5,5.5v58.9c0,3-2.5,5.5-5.5,5.5ZM308.4,166.5h16.3v-47.9h-16.3v47.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M330.2,297.4h-25c-3,0-5.5-2.5-5.5-5.5v-23c0-3,2.5-5.5,5.5-5.5h25c3,0,5.5,2.5,5.5,5.5v23c0,3-2.5,5.5-5.5,5.5ZM310.7,286.4h14v-12h-14v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M330.2,367.7h-25c-3,0-5.5-2.5-5.5-5.5v-23c0-3,2.5-5.5,5.5-5.5h25c3,0,5.5,2.5,5.5,5.5v23c0,3-2.5,5.5-5.5,5.5ZM310.7,356.7h14v-12h-14v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M330.2,344.6h-25c-3,0-5.5-2.5-5.5-5.5v-47.2c0-3,2.5-5.5,5.5-5.5h25c3,0,5.5,2.5,5.5,5.5v47.2c0,3-2.5,5.5-5.5,5.5ZM310.7,333.6h14v-36.2h-14v36.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M198.3,297.4h-25c-3,0-5.5-2.5-5.5-5.5v-23c0-3,2.5-5.5,5.5-5.5h25c3,0,5.5,2.5,5.5,5.5v23c0,3-2.5,5.5-5.5,5.5ZM178.8,286.4h14v-12h-14v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M198.3,367.7h-25c-3,0-5.5-2.5-5.5-5.5v-23c0-3,2.5-5.5,5.5-5.5h25c3,0,5.5,2.5,5.5,5.5v23c0,3-2.5,5.5-5.5,5.5ZM178.8,356.7h14v-12h-14v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M198.3,344.6h-25c-3,0-5.5-2.5-5.5-5.5v-47.2c0-3,2.5-5.5,5.5-5.5h25c3,0,5.5,2.5,5.5,5.5v47.2c0,3-2.5,5.5-5.5,5.5ZM178.8,333.6h14v-36.2h-14v36.2Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M251.8,256.8c-9.8,0-17.8-8-17.8-17.8v-9.3h-.9c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5h6.4c3,0,5.5,2.5,5.5,5.5v14.8c0,3.8,3.1,6.8,6.8,6.8s6.8-3.1,6.8-6.8v-14.8c0-3,2.5-5.5,5.5-5.5h6.4c3,0,5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5h-.9v9.3c0,9.8-8,17.8-17.8,17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M305.2,367.7h-107c-3,0-5.5-2.5-5.5-5.5v-93.3c0-3,2.5-5.5,5.5-5.5h107c3,0,5.5,2.5,5.5,5.5v93.3c0,3-2.5,5.5-5.5,5.5ZM203.8,356.7h96v-82.3h-96v82.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M251.8,367.7c-3,0-5.5-2.5-5.5-5.5v-93.3c0-3,2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5v93.3c0,3-2.5,5.5-5.5,5.5h0Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M43.8,225.3v-60c0-3.7,3.5-6.3,7-5.4l58.8,16.1c3.5,1,5.9,4.1,5.9,7.7v41.6H43.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M19.1,217.5v248.6c0,5,4,9,9,9h103.3c5,0,9-4,9-9v-248.6c0-5-4-9-9-9H28.1c-5,0-9,4-9,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M131.4,208.5h-28.4c5,0,9,4,9,9v248.6c0,5-4,9-9,9h28.4c5,0,9-4,9-9v-248.6c0-5-4-9-9-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M335.1,235.9v228.5c0,6,4.8,10.8,10.8,10.8h138.3c6,0,10.8-4.8,10.8-10.8v-228.5c0-6-4.8-10.8-10.8-10.8h-138.3c-6,0-10.8,4.8-10.8,10.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M484.2,225.1h-32.3c6,0,10.8,4.8,10.8,10.8v228.5c0,6-4.8,10.8-10.8,10.8h32.3c6,0,10.8-4.8,10.8-10.8v-228.5c0-6-4.8-10.8-10.8-10.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M365,266.5v18.9c0,2.7,2.2,4.9,4.9,4.9h18.9c2.7,0,4.9-2.2,4.9-4.9v-18.9c0-2.7-2.2-4.9-4.9-4.9h-18.9c-2.7,0-4.9,2.2-4.9,4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M436.3,340.7v18.9c0,2.7,2.2,4.9,4.9,4.9h18.9c2.7,0,4.9-2.2,4.9-4.9v-18.9c0-2.7-2.2-4.9-4.9-4.9h-18.9c-2.7,0-4.9,2.2-4.9,4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M436.3,414.9v18.9c0,2.7,2.2,4.9,4.9,4.9h18.9c2.7,0,4.9-2.2,4.9-4.9v-18.9c0-2.7-2.2-4.9-4.9-4.9h-18.9c-2.7,0-4.9,2.2-4.9,4.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M115.5,216c-4.1,0-7.5-3.4-7.5-7.5v-24.7c0-.3-.3-.4-.5-.5l-56.2-15.4v40.6c0,4.1-3.4,7.5-7.5,7.5s-7.5-3.4-7.5-7.5v-43.1c0-4.2,1.9-8,5.2-10.5,3.3-2.5,7.4-3.2,11.3-2.1l58.7,16.1c6.9,2,11.4,8,11.4,14.9v24.7c0,4.1-3.4,7.5-7.5,7.5ZM48.8,167.2s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M104.8,482.6H28.1c-9.1,0-16.5-7.4-16.5-16.5v-248.6c0-9.1,7.4-16.5,16.5-16.5h103.3c9.1,0,16.5,7.4,16.5,16.5v241.1c0,4.1-3.4,7.5-7.5,7.5s-7.5-3.4-7.5-7.5v-241.1c0-.9-.6-1.5-1.5-1.5H28.1c-.9,0-1.5.6-1.5,1.5v248.6c0,.9.6,1.5,1.5,1.5h76.7c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M58.4,261.2h-6.1c-4.1,0-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5h6.1c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M107.1,261.2h-6.1c-4.1,0-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5h6.1c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M58.4,305.3h-6.1c-4.1,0-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5h6.1c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M107.1,305.3h-6.1c-4.1,0-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5h6.1c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M58.4,349.3h-6.1c-4.1,0-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5h6.1c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M58.4,393.4h-6.1c-4.1,0-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5h6.1c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M58.4,437.5h-6.1c-4.1,0-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5h6.1c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M484.2,482.7h-125c-4.1,0-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5h125c1.9,0,3.3-1.4,3.3-3.3v-171.6c0-4.1,3.4-7.5,7.5-7.5s7.5,3.4,7.5,7.5v171.6c0,10.1-8.2,18.3-18.3,18.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M335.1,476.7c-4.1,0-7.5-3.4-7.5-7.5v-233.3c0-10.1,8.2-18.3,18.3-18.3h138.3c10.1,0,18.3,8.2,18.3,18.3v23.2c0,4.1-3.4,7.5-7.5,7.5s-7.5-3.4-7.5-7.5v-23.2c0-1.9-1.4-3.3-3.3-3.3h-138.3c-1.9,0-3.3,1.4-3.3,3.3v233.3c0,4.1-3.4,7.5-7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M459,372h-18.9c-6.8,0-12.4-5.6-12.4-12.4v-18.9c0-6.8,5.6-12.4,12.4-12.4h18.9c6.8,0,12.4,5.6,12.4,12.4v18.9c0,6.8-5.6,12.4-12.4,12.4ZM442.7,357h13.7v-13.7h-13.7v13.7ZM459,343.3h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M459,446.2h-18.9c-6.8,0-12.4-5.6-12.4-12.4v-18.9c0-6.8,5.6-12.4,12.4-12.4h18.9c6.8,0,12.4,5.6,12.4,12.4v18.9c0,6.8-5.6,12.4-12.4,12.4ZM442.7,431.2h13.7v-13.7h-13.7v13.7ZM459,417.5h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M388.8,297.8h-18.9c-6.8,0-12.4-5.6-12.4-12.4v-18.9c0-6.8,5.6-12.4,12.4-12.4h18.9c6.8,0,12.4,5.6,12.4,12.4v18.9c0,6.8-5.6,12.4-12.4,12.4ZM372.5,282.8h13.7v-13.7h-13.7v13.7ZM388.8,269.1h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M459,297.8h-18.9c-6.8,0-12.4-5.6-12.4-12.4v-18.9c0-6.8,5.6-12.4,12.4-12.4h18.9c6.8,0,12.4,5.6,12.4,12.4v18.9c0,6.8-5.6,12.4-12.4,12.4ZM442.7,282.8h13.7v-13.7h-13.7v13.7ZM459,269.1h0,0Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.1,368.8v113.2h234.1c5.7,0,10.3-4.6,10.3-10.3v-102.9l-112.5-50.1c-6.2-2.8-13.2-2.8-19.4,0l-112.5,50.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M344.3,356.3v115.4c0,5.7-4.6,10.3-10.3,10.3h28.2c5.7,0,10.3-4.6,10.3-10.3v-102.9l-28.2-12.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M333.3,442.4v33.9h-32.6v-33.9c0-3.6,2.9-6.4,6.4-6.4h19.8c3.6,0,6.4,2.9,6.4,6.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.6,442.4v33.9h-32.6v-33.9c0-3.6,2.9-6.4,6.4-6.4h19.8c3.6,0,6.4,2.9,6.4,6.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.9,442.4v33.9h-32.6v-33.9c0-3.6,2.9-6.4,6.4-6.4h19.8c3.6,0,6.4,2.9,6.4,6.4h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M387.9,383.2c-1,0-2.1-.2-3-.7l-128-57c-4.2-1.9-9-1.9-13.3,0l-128,57c-3.8,1.7-8.2,0-9.9-3.8-1.7-3.8,0-8.2,3.8-9.9l128-57c8.2-3.7,17.5-3.7,25.6,0l127.9,57c3.8,1.7,5.5,6.1,3.8,9.9-1.2,2.8-4,4.5-6.9,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M128.1,463.4c-4.1,0-7.5-3.4-7.5-7.5v-87.1c0-4.1,3.4-7.5,7.5-7.5s7.5,3.4,7.5,7.5v87.1c0,4.1-3.4,7.5-7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M372.5,478.5c-4.1,0-7.5-3.4-7.5-7.5v-102.2c0-4.1,3.4-7.5,7.5-7.5s7.5,3.4,7.5,7.5v102.2c0,4.1-3.4,7.5-7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M372.5,483.8h-244.4c-4.1,0-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5h244.4c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M333.3,483.8c-4.1,0-7.5-3.4-7.5-7.5v-32.8h-17.6v32.8c0,4.1-3.4,7.5-7.5,7.5s-7.5-3.4-7.5-7.5v-33.9c0-7.7,6.2-13.9,13.9-13.9h19.8c7.7,0,13.9,6.2,13.9,13.9v33.9c0,4.1-3.4,7.5-7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M266.5,483.8c-4.1,0-7.5-3.4-7.5-7.5v-32.8h-17.6v32.8c0,4.1-3.4,7.5-7.5,7.5s-7.5-3.4-7.5-7.5v-33.9c0-7.7,6.2-13.9,13.9-13.9h19.8c7.7,0,13.9,6.2,13.9,13.9v33.9c0,4.1-3.4,7.5-7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M199.8,483.8c-4.1,0-7.5-3.4-7.5-7.5v-32.8h-17.6v32.8c0,4.1-3.4,7.5-7.5,7.5s-7.5-3.4-7.5-7.5v-33.9c0-7.7,6.2-13.9,13.9-13.9h19.8c7.7,0,13.9,6.2,13.9,13.9v33.9c0,4.1-3.4,7.5-7.5,7.5Z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M259.4,407.6h-18.9c-6.8,0-12.4-5.6-12.4-12.4v-18.9c0-6.8,5.6-12.4,12.4-12.4h18.9c6.8,0,12.4,5.6,12.4,12.4v18.9c0,6.8-5.6,12.4-12.4,12.4ZM243.1,392.6h13.7v-13.7h-13.7v13.7ZM259.4,378.9h0,0Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresasMain);
export default __webpack_public_path__ + "static/media/empresas-main.b1b0808f4b57e0ae8bcc3b243ba20fe5.svg";
export { ForwardRef as ReactComponent };